class StartSsoAuthentication {
	constructor(
		public readonly email: string,
		public readonly redirectPath: string | null,
	) {
		Object.freeze(this);
	}

	// `redirectPath` is omitted from the body when absent, never sent as `null`.
	toJSON(): Record<string, unknown> {
		const body: Record<string, unknown> = {
			email: this.email,
		};

		if (this.redirectPath !== null) {
			body.redirectPath = this.redirectPath;
		}

		return body;
	}
}

export default StartSsoAuthentication;
